<template>
    <div>
        <div v-if="['restaurant', 'billets-non-dates'].includes(widgetId)">
            <span class="ppv2-block ppv2-text-sm poppinsSemiBold ppv2-text-black ppv2-opacity-80 ppv2-mb-2">
                {{ $t('codeModal.cookieManagement') }}
                <span
                    class="ppv2-inline-flex ppv2-h-4 ppv2-w-4 ppv2-items-center ppv2-justify-center ppv2-rounded-full ppv2-bg-black ppv2-bg-opacity-20 ppv2-text-xs ppv2-text-black ppv2-bg-opacity-50 poppinsSemiBold ppv2-cursor-help ppv2-ml-0.5"
                >
                    ?
                </span>
            </span>

            <div
                class="ppv2-grid ppv2-grid-cols-2 ppv2-rounded-2xl bg-purple ppv2-bg-opacity-10 ppv2-p-1 ppv2-border ppv2-border-black ppv2-border-opacity-10"
            >
                <button
                    @click="updateConsent(false)"
                    :class="[
                        !value
                            ? 'ppv2-bg-white dark:ppv2-bg-dark ppv2-text-[#7D2DBD] ppv2-shadow-sm poppinsSemiBold'
                            : 'ppv2-text-black ppv2-opacity-50 poppinsMedium',
                    ]"
                    class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-1.5 ppv2-rounded-xl ppv2-py-2.5 ppv2-text-sm ppv2-transition"
                >
                    <svg
                        v-if="!value"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    {{ $t('codeModal.withoutCookieBanner') }}
                </button>

                <button
                    @click="updateConsent(true)"
                    :class="[
                        value
                            ? 'ppv2-bg-white  dark:ppv2-bg-dark ppv2-text-[#7D2DBD] ppv2-shadow-sm poppinsSemiBold'
                            : 'ppv2-text-black ppv2-opacity-50 poppinsMedium',
                    ]"
                    class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-1.5 ppv2-rounded-xl ppv2-py-2.5 ppv2-text-sm ppv2-transition"
                >
                    <svg
                        v-if="value"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    {{ $t('codeModal.withCookieBanner') }}
                </button>
            </div>

            <p class="ppv2-text-xs ppv2-text-black ppv2-opacity-50 ppv2-mt-2 ppv2-pl-1">
                {{ value ? $t('codeModal.cookieConsentHint') : $t('codeModal.noCookieConsentHint') }}
            </p>
        </div>
        <div v-else-if="['activite', 'evenements', 'formules', 'abonnements', 'forfaits', 'devis'].includes(widgetId)">
            <template v-if="inModal">
                <span class="ppv2-block ppv2-text-sm poppinsSemiBold ppv2-text-black ppv2-opacity-80 ppv2-mb-2">
                    {{ $t('codeModal.cookieManagement') }}
                    <span
                        class="ppv2-inline-flex ppv2-h-4 ppv2-w-4 ppv2-items-center ppv2-justify-center ppv2-rounded-full ppv2-bg-black ppv2-bg-opacity-20 ppv2-text-xs ppv2-text-black ppv2-bg-opacity-50 poppinsSemiBold ppv2-cursor-help ppv2-ml-0.5"
                    >
                        ?
                    </span>
                </span>

                <div
                    class="ppv2-grid ppv2-grid-cols-2 ppv2-rounded-2xl bg-purple ppv2-bg-opacity-10 ppv2-p-1 ppv2-border ppv2-border-black ppv2-border-opacity-10"
                >
                    <button
                        @click="updateConsent(false)"
                        :class="[
                            !value
                                ? 'ppv2-bg-white dark:ppv2-bg-dark ppv2-text-[#7D2DBD] ppv2-shadow-sm poppinsSemiBold'
                                : 'ppv2-text-black ppv2-opacity-50 poppinsMedium',
                        ]"
                        class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-1.5 ppv2-rounded-xl ppv2-py-2.5 ppv2-text-sm ppv2-transition"
                    >
                        <Check v-if="!value"></Check>
                        {{ $t('codeModal.withoutCookieBanner') }}
                    </button>

                    <button
                        @click="updateConsent(true)"
                        :class="[
                            value
                                ? 'ppv2-bg-white dark:ppv2-bg-dark ppv2-text-[#7D2DBD] ppv2-shadow-sm poppinsSemiBold'
                                : 'ppv2-text-black ppv2-opacity-50 poppinsMedium',
                        ]"
                        class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-1.5 ppv2-rounded-xl ppv2-py-2.5 ppv2-text-sm ppv2-transition"
                    >
                        <Check v-if="value"></Check>
                        {{ $t('codeModal.withCookieBanner') }}
                    </button>
                </div>

                <p class="ppv2-text-xs ppv2-text-black ppv2-opacity-50 ppv2-mt-2 ppv2-pl-1">
                    {{ value ? $t('codeModal.cookieConsentHint') : $t('codeModal.noCookieConsentHint') }}
                </p>
            </template>
            <template v-else>
                <span class="ppv2-block ppv2-text-sm poppinsSemiBold ppv2-text-black ppv2-opacity-80 ppv2-mb-2">
                    {{ $t('codeModal.whatToDisplay') }}
                    <span
                        class="ppv2-inline-flex ppv2-h-4 ppv2-w-4 ppv2-items-center ppv2-justify-center ppv2-rounded-full ppv2-bg-black ppv2-bg-opacity-20 ppv2-text-xs ppv2-text-black ppv2-bg-opacity-50 poppinsSemiBold ppv2-cursor-help ppv2-ml-0.5"
                    >
                        ?
                    </span>
                </span>

                <div
                    class="ppv2-grid ppv2-grid-cols-2 ppv2-rounded-2xl bg-purple ppv2-bg-opacity-10 ppv2-p-1 ppv2-border ppv2-border-black ppv2-border-opacity-10"
                >
                    <button
                        @click="updateConsent(false)"
                        :class="[
                            !value
                                ? 'ppv2-bg-white dark:ppv2-bg-dark ppv2-text-[#7D2DBD] ppv2-shadow-sm poppinsSemiBold'
                                : 'ppv2-text-black ppv2-opacity-50 poppinsMedium',
                        ]"
                        class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-1.5 ppv2-rounded-xl ppv2-py-2.5 ppv2-text-sm ppv2-transition"
                    >
                        <Check v-if="!value"></Check>
                        {{ $t('codeModal.allList') }}
                    </button>

                    <button
                        @click="updateConsent(true)"
                        :class="[
                            value
                                ? 'ppv2-bg-white dark:ppv2-bg-dark ppv2-text-[#7D2DBD] ppv2-shadow-sm poppinsSemiBold'
                                : 'ppv2-text-black ppv2-opacity-50 poppinsMedium',
                        ]"
                        class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-1.5 ppv2-rounded-xl ppv2-py-2.5 ppv2-text-sm ppv2-transition"
                    >
                        <Check v-if="value"></Check>
                        {{ $t('codeModal.oneInParticular') }}
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { Check } from 'lucide-vue'
export default {
    name: 'CookieManagementToggle',
    components: {
        Check,
    },
    props: {
        // Vue 2 default prop name for v-model mapping is 'value'
        value: {
            type: Boolean,
            required: true,
        },
        widgetId: {
            type: String,
            required: true,
        },
        inModal: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateConsent(newValue) {
            // Sends the updated status back to the parent component
            this.$emit('input', newValue)
        },
    },
}
</script>
